import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useNuxtApp } from '#app'
import { useSyncData } from '@/composables/useSyncData'
import { useAuthStore } from '@/stores/useAuthStore'
import type { Voucher } from '@/_api/models/voucher'

export const useVoucherStore = defineStore('voucher', () => {
  const { $api, $features, $grants } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<Voucher>({
    service: $api.voucher,
    key: 'voucher',
    accountId,
    feature: 'vouchers',
    grants: { voucher: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if (!$features.get('vouchers')) {
      return
    }

    if (!$grants.all({ voucher: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const all = computed(() => items.value)
  const syncDate = computed(() => syncState.value.date)

  return {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
  }
})
